import React from "react";
import styles from "../../assets/styles/_hairCheck.module.scss";

const Step1 = ({ setStep, setType }) => {
  return (
    <div className={styles.step1}>
      <div className={styles.txt1}>Q1.</div>
      <div className={styles.title}>髪の太さは？</div>
      <div className={styles.txt2}>
        髪の毛を1本指で転がしてみた時の <br />
        感触で回答してください。
      </div>
      <hr className={styles.line} />
      <div
        className={`${styles.btn} ${styles.btn1}`}
        onClick={() => {
          setType("pink");
          setStep(2);
        }}
      >
        <div className={styles.titleBtn}>太い</div>
        <div className={styles.des}>
          髪が硬く弾力がある <br />
          髪の毛1本を触った際に毛の感触を強く感じる
        </div>
      </div>
      <div
        className={`${styles.btn} ${styles.btn2}`}
        onClick={() => {
          setType("blue");
          setStep(2);
        }}
      >
        <div className={styles.titleBtn}>細い</div>
        <div className={styles.des2}>
          髪が柔らかく弾力がない<br />
          髪の毛1本を触った際の毛の感触は<br />
          ほどんどない
        </div>
      </div>
    </div>
  );
};

export default Step1;
